import { joinParts } from '../utils'

export const event = {
  data: (idOrCodeurl: string) => joinParts('events', idOrCodeurl),
  bulk: (idsOrCodeUrls: string[]) => `/events?ids=${idsOrCodeUrls.join(',')}`,
}
